export const DRAW_MANAGER_TAB_REC_ID = 'FD9A944253294BA4884DDB7DD5FAFD4F';
export const DRAW_REQUEST_ENTITY_TYPE = 'drawRequest';

export const DRAW_REQUEST_STATUS = {
  NEW: 1,
  IN_REVIEW: 2,
  APPROVED: 3,
  DISBURSED: 4,
  CANCELLED: 5,
} as const;

export const DRAW_REQUEST_STATUS_LABELS = {
  [DRAW_REQUEST_STATUS.NEW]: 'Submitted',
  [DRAW_REQUEST_STATUS.IN_REVIEW]: 'In Review',
  [DRAW_REQUEST_STATUS.APPROVED]: 'Approved',
  [DRAW_REQUEST_STATUS.DISBURSED]: 'Disbursed',
  [DRAW_REQUEST_STATUS.CANCELLED]: 'Cancelled',
} as const;

export const DEFAULT_SORT_ORDER = {
  name: 'Id',
  direction: 'asc' as const,
} as const;

export const DRAW_REQUEST_PAGINATION_OPTIONS = [10, 25, 50, 100] as const;

export const MESSAGES_DEFAULT_OFFSET = 0;
export const MESSAGES_DEFAULT_LIMIT = 50;
export const MESSAGES_LOAD_MORE_LIMIT = 50;

export const MESSAGE_DATE_FORMAT_OPTIONS = {
  locale: 'en-US',
  options: {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  },
} as const;

export const MESSAGE_TIMESTAMP_FORMAT_OPTIONS = {
  locale: 'en-US',
  options: {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  },
} as const;
